import { component, Component, ComponentPolicy, property } from '../../../concepts/objects';

const callReferenceDef = {
    name: 'CallReference',
    implements: [],
};

const callReferencePolicy = ComponentPolicy.create({
    allowAdd: () => [false, 'CallReference cannot have children.']
});

@component(callReferenceDef)
export class CallReference extends Component {

    protected get policy() {
        return callReferencePolicy;
    }

    @property({ type: 'string' })
    public name: string;

    @property({ type: 'string' })
    public url: string;

}
